<app-page-header
  class="header"
  [inside]="true"
  [backSwipe]="backSwipeConfig"
  (backButtonClick)="back.emit()"
/>

<img
  class="logo"
  height="80"
  width="250"
  src="/images/logo.svg"
  alt="Sunset Grill logo">

<div class="content">
  <span class="title">Leave a Review!</span>
  <span class="description">We’d love to hear from you. Scan the QR Code to leave a Google Review!</span>
  <div class="link">
    <app-qrcode content="https://oon.gl/PVKwfb" [size]="264"/>
    <span class="label">Leave a review</span>
  </div>
</div>
